import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNuclearPowerPlant: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="nuclear-power-plant, radiation"><path d="M9 20.25H2.75C4.84768 14.25 5.40756 10.0642 5.89652 3.75H16.8849C17.0943 6.45374 17.3167 8.76723 17.6672 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 17C8.75 13.4363 11.4363 10.75 15 10.75C18.5637 10.75 21.25 13.4363 21.25 17V20.25H8.75V17Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9 16.25H21" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconNuclearPowerPlant;
